import gql from 'graphql-tag';
import {
  COUPON_FRAGMENT,
  DISCOUNT_ACTIVITY_FRAGMENT,
  FULL_DISCOUNT_PRESENT_FRAGMENT,
  PACKAGE_DISCOUNT_FRAGMENT,
  PURCHASE_PREMIUM_FRAGMENT,
  SELECTIVE_GIFT_ACTIVITY_FRAGMENT,
  SHOPPING_CREDITS_CLAIM_ACTIVITY_FRAGMENT,
  SHOPPING_CREDITS_DEDUCTION_ACTIVITY_FRAGMENT,
} from '../fragments';

/**
 * 商品对应的所有活动信息数据
 */
export const fetchProductActivitiesFindAllDocument = gql`
  query productActivitiesFindAll($productId: ID!) {
    productActivitiesFindAll(productId: $productId) {
      ... on Coupon {
        ...Coupon
      }
      ... on PurchasePremium {
        ...PurchasePremium
      }
      ... on DiscountActivity {
        ...DiscountActivity
      }
      ... on FullDiscountPresent {
        ...FullDiscountPresent
      }
      ... on PackageDiscount {
        ...PackageDiscount
      }
      ... on SelectiveGiftActivity {
        ...SelectiveGiftActivity
      }
      ... on ShoppingCreditsClaimActivity {
        ...ShoppingCreditsClaimActivity
      }
      ... on ShoppingCreditsDeductionActivity {
        ...ShoppingCreditsDeductionActivity
      }
    }
  }
  ${COUPON_FRAGMENT}
  ${PURCHASE_PREMIUM_FRAGMENT}
  ${DISCOUNT_ACTIVITY_FRAGMENT}
  ${FULL_DISCOUNT_PRESENT_FRAGMENT}
  ${PACKAGE_DISCOUNT_FRAGMENT}
  ${SELECTIVE_GIFT_ACTIVITY_FRAGMENT}
  ${SHOPPING_CREDITS_CLAIM_ACTIVITY_FRAGMENT}
  ${SHOPPING_CREDITS_DEDUCTION_ACTIVITY_FRAGMENT}
`;

/**
 * 商品对应的单项活动信息数据 - 暂时废弃
 */
export const fetchProductActivitiesFindOneDocument = gql`
  query productActivitiesFindOne($id: ID!) {
    productActivitiesFindOne(id: $id) {
      ... on Coupon {
        ...Coupon
      }
      ... on PurchasePremium {
        ...PurchasePremium
      }
      ... on DiscountActivity {
        ...DiscountActivity
      }
      ... on FullDiscountPresent {
        ...FullDiscountPresent
      }
      ... on PackageDiscount {
        ...PackageDiscount
      }
      ... on SelectiveGiftActivity {
        ...SelectiveGiftActivity
      }
      ... on ShoppingCreditsClaimActivity {
        ...ShoppingCreditsClaimActivity
      }
      ... on ShoppingCreditsDeductionActivity {
        ...ShoppingCreditsDeductionActivity
      }
    }
  }
  ${COUPON_FRAGMENT}
  ${PURCHASE_PREMIUM_FRAGMENT}
  ${DISCOUNT_ACTIVITY_FRAGMENT}
  ${FULL_DISCOUNT_PRESENT_FRAGMENT}
  ${PACKAGE_DISCOUNT_FRAGMENT}
  ${SELECTIVE_GIFT_ACTIVITY_FRAGMENT}
  ${SHOPPING_CREDITS_CLAIM_ACTIVITY_FRAGMENT}
  ${SHOPPING_CREDITS_DEDUCTION_ACTIVITY_FRAGMENT}
`;

/**
 * 添加赠品
 */
export const fetchSelectGiftDocument = gql`
  mutation selectGift(
    $orderId: ID!
    $skuId: ID!
    $giftId: ID!
    $promInstanceId: ID!
    $ladderLevel: Int
  ) {
    selectGift(
      orderId: $orderId
      skuId: $skuId
      giftId: $giftId
      promInstanceId: $promInstanceId
      ladderLevel: $ladderLevel
    ) {
      id
    }
  }
`;

/**
 * 删除赠品
 */
export const fetchCancelGiftDocument = gql`
  mutation cancelGift($orderId: ID!, $giftId: ID!, $promInstanceId: ID!) {
    cancelGift(orderId: $orderId, giftId: $giftId, promInstanceId: $promInstanceId) {
      id
    }
  }
`;

/**
 * 选择优惠换购商品
 */
export const fetchSelectMarkUpDocument = gql`
  mutation selectMarkUp($orderId: ID!, $skuId: ID!, $productId: ID!, $promInstanceId: ID!) {
    selectMarkUp(
      orderId: $orderId
      skuId: $skuId
      productId: $productId
      promInstanceId: $promInstanceId
    ) {
      id
    }
  }
`;

/**
 * 取消选择优惠换购商品
 */
export const fetchCancelMarkUpDocument = gql`
  mutation cancelMarkUp($orderId: ID!, $productId: ID!, $promInstanceId: ID!) {
    cancelMarkUp(orderId: $orderId, productId: $productId, promInstanceId: $promInstanceId) {
      id
    }
  }
`;

/**
 * 根据订单id查询赠品
 */
export const fetchFreeGiftByOrderDocument = gql`
  query freeGiftByOrder($orderId: ID!) {
    freeGiftByOrder(orderId: $orderId) {
      id
      name
      status
      product {
        id
        name
        enabled
        customFields {
          isVipProduct
          unit
        }
        optionGroups {
          id
          code
          name
          customFields {
            priority
          }
          options {
            id
            code
            name
            customFields {
              priority
            }
          }
        }
        variants {
          id
          name
          options {
            code
            name
            id
            group {
              id
              code
              name
            }
          }
          featuredAsset {
            source
          }
          isThereAnyStock
          price
          priceWithTax
          sku
        }
        featuredAsset {
          source
        }
        customFields {
          price
          markingPrice
        }
      }
    }
  }
`;

/**
 * 根据订单id查询换购商品
 */
export const fetchMarkUpByOrderDocument = gql`
  query markUpByOrder($orderId: ID!) {
    markUpByOrder(orderId: $orderId) {
      ...PurchasePremium
    }
  }
  ${PURCHASE_PREMIUM_FRAGMENT}
`;

/**
 * 取消加价购全部商品
 */
export const fetchCancelAllMarkUpDocument = gql`
  mutation cancelAllMarkUp($orderId: ID!) {
    cancelAllMarkUp(orderId: $orderId) {
      id
    }
  }
`;

/**
 * 获取满减活动详情
 */
export const fetchFullDiscountPresentDocument = gql`
  query fullDiscountPresent($id: ID!, $options: FullDiscountPresentListOptions) {
    fullDiscountPresent(id: $id, options: $options) {
      ...FullDiscountPresent
    }
  }
  ${FULL_DISCOUNT_PRESENT_FRAGMENT}
`;

/**
 * 获取x件y折活动详情
 */
export const fetchDiscountActivityDocument = gql`
  query discountActivity($discountActivityId: ID!, $options: DiscountActivityListOptions) {
    discountActivity(discountActivityId: $discountActivityId, options: $options) {
      ...DiscountActivity
    }
  }
  ${DISCOUNT_ACTIVITY_FRAGMENT}
`;

/**
 * 获取加价购活动详情
 */
export const fetchPurchasePremiumDocument = gql`
  query purchasePremium($purchasePremiumId: ID!, $options: PurchasePremiumListOptions) {
    purchasePremium(purchasePremiumId: $purchasePremiumId, options: $options) {
      ...PurchasePremium
    }
  }
  ${PURCHASE_PREMIUM_FRAGMENT}
`;

// 打包一口价
export const fetchPackageDiscountDocument = gql`
  query packageDiscount($id: ID!, $options: PackageDiscountListOptions) {
    packageDiscount(id: $id, options: $options) {
      ...PackageDiscount
    }
  }
  ${PACKAGE_DISCOUNT_FRAGMENT}
`;

/** 根据订单查询支付有礼优惠券 */
export const fetchOrderPaymentRewardCouponsDocument = gql`
  query orderPaymentRewardCoupons($orderId: ID!, $options: OrderPaymentRewardCouponListOptions) {
    orderPaymentRewardCoupons(orderId: $orderId, options: $options) {
      items {
        id
        createdAt
        updatedAt
        orderId
        userCouponId
        couponId
        paymentRewardActivityId
        coupon {
          ...Coupon
        }
        isClaimed
        isUsed
      }
      totalItems
    }
  }
  ${COUPON_FRAGMENT}
`;

/** 支付有礼 - 领取优惠券 */
export const fetchReceivePaymentRewardCouponDocument = gql`
  mutation receivePaymentRewardCoupon($orderPaymentRewardCouponId: ID!) {
    receivePaymentRewardCoupon(orderPaymentRewardCouponId: $orderPaymentRewardCouponId) {
      id
      createdAt
      updatedAt
      orderId
      userCouponId
      couponId
      paymentRewardActivityId
      coupon {
        ...Coupon
      }
      isClaimed
      isUsed
    }
  }
  ${COUPON_FRAGMENT}
`;

/** 获取当前活动是否异常 */
export const fetchAreAllEligibleProductsInactiveOrSoldOutDocument = gql`
  query areAllEligibleProductsInactiveOrSoldOut($promotionId: ID!, $promotionType: PromotionType!) {
    areAllEligibleProductsInactiveOrSoldOut(
      promotionId: $promotionId
      promotionType: $promotionType
    )
  }
`;

/**
 * 获取购物金活动详情
 */
export const fetchShoppingCreditsClaimActivityDocument = gql`
  query shoppingCreditsClaimActivity(
    $shoppingCreditsClaimActivityId: ID!
    $options: ShoppingCreditsClaimActivityListOptions
  ) {
    shoppingCreditsClaimActivity(
      shoppingCreditsClaimActivityId: $shoppingCreditsClaimActivityId
      options: $options
    ) {
      ...ShoppingCreditsClaimActivity
    }
  }
  ${SHOPPING_CREDITS_CLAIM_ACTIVITY_FRAGMENT}
`;

/**
 * 获取购物金抵扣活动详情
 */
export const fetchShoppingCreditsDeductionActivityDocument = gql`
  query shoppingCreditsDeductionActivity(
    $shoppingCreditsDeductionActivityId: ID!
    $options: ShoppingCreditsDeductionActivityListOptions
  ) {
    shoppingCreditsDeductionActivity(
      shoppingCreditsDeductionActivityId: $shoppingCreditsDeductionActivityId
      options: $options
    ) {
      ...ShoppingCreditsDeductionActivity
    }
  }
  ${SHOPPING_CREDITS_DEDUCTION_ACTIVITY_FRAGMENT}
`;
